import ISessionLocation from "../interfaces/ISessionLocation";
import APIService from "./API.service";
const queryString = require("query-string");

class LocationService extends APIService {
  // Get the locations of the event sessions
  getLocations(eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };

    return this.call.get(
      `${this.apiUrl}/locations?${queryString.stringify(query)}`
    );
  }

  // Create a new location
  createLocation(
    eventId: number,
    params: { name: string; thirdPartyId?: string }
  ): Promise<ISessionLocation> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    return this.call.post(
      `${this.apiUrl}/locations?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }
}

export default LocationService;
